function Line({ className }: { className?: string }) {
  return <div className={`bg-stroke w-full h-[1px] ${className}`} />
}

export default Line
